import { Injectable } from '@angular/core';
import { dayjs } from '@shared/utils';
import { CreatePrereservationRequestDto, SimplePrereservationDto } from '../dto';
import { BookingDetailsModel, TimeSlotBookingModel, TimeSlotMetadata } from '../model';

@Injectable({
    providedIn: 'root',
})
export class PrereservationMapper {
    public toCreatePrereservationRequestDto(
        bookingInfo: BookingDetailsModel,
        selectedTimeslot: TimeSlotBookingModel,
        timeslotMetadata: TimeSlotMetadata,
        maskedCustomerId?: string,
        maskedBsId?: string,
        bsid?: number,
        caseId?: string,
    ): CreatePrereservationRequestDto {
        return {
            contractorUuid: timeslotMetadata.contractorUuid,
            subcontractorUuid: timeslotMetadata.subcontractorUuid,
            serviceUuid: timeslotMetadata.contractorServiceUuid,
            maskedCustomerId: maskedCustomerId || bookingInfo.bookingAllowanceinfo?.maskedCustomerId || '',
            maskedBsId: maskedBsId || bookingInfo.bookingAllowanceinfo?.maskedBsId || '',
            from: selectedTimeslot.start ? dayjs(selectedTimeslot.start).format('YYYY-MM-DDTHH:mm:ss.SSSZ') : '',
            to: selectedTimeslot.end ? dayjs(selectedTimeslot.end).format('YYYY-MM-DDTHH:mm:ss.SSSZ') : '',
            forceUpdate: false,
            originUrl: 'PWA',
            reservationType: 'WIDGET',
            bsid: bsid || bookingInfo.bookingAllowanceinfo?.bsId || 0,
            caseId: caseId || bookingInfo.bookingAllowanceinfo?.caseId || '',
            service: {
                name: timeslotMetadata.contractorServiceName || '',
            },
            scheduleId: selectedTimeslot.scheduleId || '',
            noOfReservations: 1,
        };
    }

    public toSimplePrereservationDto(
        prereservationId: string,
        bookingInfo: BookingDetailsModel,
        timeslotMetadata: TimeSlotMetadata,
        maskedBsId?: string,
        caseId?: string,
    ): SimplePrereservationDto {
        return {
            prereservationId: prereservationId,
            caseId: caseId || bookingInfo.bookingAllowanceinfo?.caseId || '',
            contractorUuid: timeslotMetadata.contractorUuid,
            maskedBsId: maskedBsId || bookingInfo.bookingAllowanceinfo?.maskedBsId || '',
        };
    }
}
